var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyncIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh-cw-alt-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7 12C4.23858 12 2 9.76142 2 7C2 5.71941 2.48142 4.55126 3.27316 3.66667L4.77778 2M7 2C9.76142 2 12 4.23858 12 7C12 8.28059 11.5186 9.44874 10.7268 10.3333L9.22222 12M2 2H4.77778M4.77778 2V4.77778M12 12H9.22222M9.22222 12V9.22222",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncIcon);
export default __webpack_public_path__ + "static/media/syncIcon.8847f08ffeb9e4993d4590fc3375eba4.svg";
export { ForwardRef as ReactComponent };